<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const name = ref('');
const email = ref('');
const phone = ref('');
const password = ref('');
const errorMessage = ref(null);
const router = useRouter();
const authStore = useAuthStore();

const handleRegister = async () => {
  errorMessage.value = null;
  try {
    if (!name.value || !email.value || !phone.value || !password.value) {
      errorMessage.value = 'All fields are required!';
      return;
    }

    await authStore.register(name.value, email.value, phone.value, password.value);
    await router.push('/login');
  } catch (error) {
    errorMessage.value = error.message;
  }
};
</script>

<template>
  <Transition name="fade">
    <div class="flex items-center justify-center min-h-screen bg-white dark:bg-gray-800">
      <div class="w-full max-w-md p-8 space-y-6 bg-white dark:bg-gray-700 bg-opacity-90 backdrop-filter backdrop-blur-lg rounded-xl shadow-xl">
        <img src="/images/electride_app-icon.svg" alt="Logo" class="w-24 mx-auto" />
        <h1 class="text-3xl font-bold text-center text-gray-800 dark:text-gray-100">Register</h1>
        <form @submit.prevent="handleRegister" class="space-y-2">

          <!-- Name Field -->
          <div class="relative">
            <label for="name" class="block mb-1 text-sm font-medium text-gray-700">Name</label>
            <input
                v-model="name"
                type="text"
                id="name"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600 focus:ring-emerald-500 transition duration-200 ease-in-out"
                placeholder="Enter your name"
            />
          </div>

          <!-- Email Field -->
          <div class="relative">
            <label for="email" class="block mb-1 text-sm font-medium text-gray-700">Email</label>
            <input
                v-model="email"
                type="email"
                id="email"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600 focus:ring-emerald-500 transition duration-200 ease-in-out"
                placeholder="Enter your email"
            />
          </div>

          <!-- Phone Field -->
          <div class="relative">
            <label for="phone" class="block mb-1 text-sm font-medium text-gray-700">Phone</label>
            <input
                v-model="phone"
                type="tel"
                id="phone"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600 focus:ring-emerald-500 transition duration-200 ease-in-out"
                placeholder="Enter your phone number"
            />
          </div>

          <!-- Password Field -->
          <div class="relative">
            <label for="password" class="block mb-1 text-sm font-medium text-gray-700">Password</label>
            <input
                v-model="password"
                type="password"
                id="password"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600 focus:ring-emerald-500 transition duration-200 ease-in-out"
                placeholder="Enter your password"
            />
          </div>

          <!-- Submit Button -->
          <div class="relative mt-4 pt-4">
            <button
              type="submit"
              class="w-full px-4 py-2 font-semibold text-black bg-emerald-500 rounded-md hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-opacity-50 transition-transform transform hover:scale-105 duration-300 ease-in-out"
          >
            Register
          </button>

          <div class="flex items-center justify-between text-center space-x-1 mt-4">
            <router-link to="/login" class="text-sm text-emerald-600 dark:text-emerald-200 hover:underline font-semibold" style="font-size: 16px;">
              Already have an account?
            </router-link>
          </div>
          </div>

        </form>

        <!-- Error Message -->
        <Transition name="slide-down">
          <p v-if="errorMessage" class="text-sm text-red-600 text-center">{{ errorMessage }}</p>
        </Transition>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
/* Animaciones */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.slide-down-enter-active {
  transition: all 0.5s ease;
}
.slide-down-enter-from {
  transform: translateY(-10px);
  opacity: 0;
}
.slide-down-enter-to {
  transform: translateY(0);
  opacity: 1;
}
</style>
